window.MathJax = {
    loader: {load: ["input/tex", "output/chtml", '[tex]/cancel', '[tex]/enclose']},
    tex: {
        inlineMath: [
            ["$", "$"],
            ["\\(", "\\)"],
            ["$$", "$$"],
        ],
        displayMath: [
            ["$", "$"],
            ["\\(", "\\)"],
            ["$$", "$$"],
        ],
        processEscapes: true,
        processEnvironments: true,
        processRefs: true,
        packages: {
            '[+]': ['cancel', 'enclose'],
        }
    },
    chtml: {
        displayAlign: 'right',
    },
    options: {
        enableMenu: false,
        ignoreHtmlClass: '.tox',
    },
    "HTML-CSS": {
        linebreaks: { automatic: true, width: "container" },
        styles: {
            ".MathJax": {
                "background-color": "#FFFF88",
                color:   "#CC0000",
                border:  "1px solid #CC0000",
                padding: "1px 3px",
                "font-family": "Dana",
                "font-style": "normal",
                "font-size":  "90%"
            },
            ".MathJax_Preview": {color: "#888888"}
        }
    }
}